import { render, staticRenderFns } from "./ls-settings.vue?vue&type=template&id=2e33d8a5&scoped=true"
import script from "./ls-settings.vue?vue&type=script&lang=js"
export * from "./ls-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33d8a5",
  null
  
)

export default component.exports